import { CompositeLayer } from '@deck.gl/core';
import { IconLayer, ScatterplotLayer } from '@deck.gl/layers';
import { MapMarkerType } from '../../../../store/mst/models';
import { WHITE_RGB } from '../../constants';
import ICON_MAPPING from '../iconMapping';

const CIRCLE_RADIUS = 14;
const CIRCLE_LINE_WIDTH = 1;
const GLYPH_SIZE = 18;

interface OrderAttemptMarkerLayerProps {
  id: string;
  visible: boolean;
  data: MapMarkerType[];
}

const isMissed = (v: MapMarkerType) => v.properties.type === 'skipped';

const getPosition = (v: MapMarkerType) => v.geometry.coordinates;

class OrderAttemptMarkerLayer extends CompositeLayer<MapMarkerType, OrderAttemptMarkerLayerProps> {
  renderLayers() {
    const { data, visible } = this.props;

    const sharedProps = {
      data,
      visible,
      pickable: false,
      getPosition,
    };

    const circleLayerProps = this.getSubLayerProps({
      ...sharedProps,
      id: 'order-attempt-circle',
      stroked: true,
      filled: true,
      radiusUnits: 'pixels',
      getRadius: () => CIRCLE_RADIUS,
      lineWidthUnits: 'pixels',
      getLineWidth: () => CIRCLE_LINE_WIDTH,
      // Missed orders use a pale fill with a colored ring; delivered orders are solid with a white ring.
      getFillColor: (v: MapMarkerType) => (isMissed(v) ? v.properties.color.rgbLighter : v.properties.color.rgb),
      getLineColor: (v: MapMarkerType) => (isMissed(v) ? v.properties.color.rgb : WHITE_RGB),
    });

    const glyphLayerProps = this.getSubLayerProps({
      ...sharedProps,
      id: 'order-attempt-glyph',
      iconAtlas: '/icon-map.png',
      iconMapping: ICON_MAPPING,
      getIcon: (v: MapMarkerType) => v.properties.type,
      getSize: () => GLYPH_SIZE,
      getColor: (v: MapMarkerType) => (isMissed(v) ? v.properties.color.rgb : WHITE_RGB),
    });

    return [
      new ScatterplotLayer(circleLayerProps),
      new IconLayer(glyphLayerProps),
    ];
  }
}

OrderAttemptMarkerLayer.layerName = 'OrderAttemptMarkerLayer';

export default OrderAttemptMarkerLayer;
